var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMapPin(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "100px",
    width: "100px",
    fill: "#4c4c4e",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 100 100",
    style: {
      enableBackground: "new 0 0 100 100"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50,100c-1.1,0-2.1-0.5-2.8-1.3c-3.6-4.1-35.5-40.4-35.5-60.4C11.7,17.2,28.9,0,50,0s38.3,17.2,38.3,38.3  c0,19.9-31.9,56.3-35.5,60.4C52.1,99.5,51.1,100,50,100z M50,7.6c-16.9,0-30.7,13.8-30.7,30.7c0,13.2,20.1,39.5,30.7,52.1  c10.6-12.5,30.7-38.9,30.7-52.1C80.7,21.4,66.9,7.6,50,7.6z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M50,58c-10.6,0-19.2-8.6-19.2-19.2c0-10.6,8.6-19.2,19.2-19.2c10.6,0,19.2,8.6,19.2,19.2C69.2,49.4,60.6,58,50,58z M50,27.2  c-6.4,0-11.6,5.2-11.6,11.6S43.6,50.4,50,50.4c6.4,0,11.6-5.2,11.6-11.6S56.4,27.2,50,27.2z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapPin);
export default __webpack_public_path__ + "static/media/map_pin.08e94035.svg";
export { ForwardRef as ReactComponent };